import { useContext } from 'react'
import { ProjectContext } from 'src/context/project/ProjectContext'

const useProjectId = () => {
  const projectContext = useContext(ProjectContext)
  return projectContext.state.currentProject
}

export default useProjectId
